import React from 'react';

import {AaSequenceAnnotationsPanelState} from 'FileStates';
import AaSequence from 'molbio/aa-sequences/AaSequence';
import AaSequenceAnnotationsPanel from 'toolbar/aa-sequence/AaSequenceAnnotationsPanel';
import ReactPanelBaseView, {getTabAndPanelIds, Subpanel} from 'toolbar/ReactPanelBaseView';

class AaSequenceAnnotationsPanelView extends ReactPanelBaseView<AaSequenceAnnotationsPanelState, AaSequence> {
  _jumpToSelection = (start: number, end: number): void => {
    this.model.selection().triggerJump(start, end);
  };

  getSubpanels(): Array<Subpanel> {
    return [
      {
        ...getTabAndPanelIds('aaSequenceAnnotations'),
        title: 'Annotations',
        component: (
          <AaSequenceAnnotationsPanel proteinId={this.model.id} jumpToSelection={this._jumpToSelection} />
        ),
      },
    ];
  }
}

export default AaSequenceAnnotationsPanelView;
